import { createModelStore } from '@/shared/stores/create-model-store'
import { model14InitialModel } from './initial-state'
import { model14DimensionHandlers } from './dimensions'

export const useModel14Store = createModelStore({
  initialModel: model14InitialModel,
  dimensionHandlers: model14DimensionHandlers,
})
